import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import InlineColor from "../../../../src/components/InlineColor.jsx";
import * as React from 'react';
export default {
  BlogMidCTA,
  InlineColor,
  React
};